export enum PageMode {
  User = 'user',
  Admin = 'admin',
  Account_Manager = 'account_manager',
}
